import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

const logo1 = 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/dwypd_clear_logo.webp';
const logo2 = 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/german_Logo.webp';
const logo3 = 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/sci_color.webp';
const logo4 = 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/pfplogo.webp';

// Repeat logos to make loop effect
const clientLogos = [logo1, logo2, logo3, logo4, logo1, logo2, logo3, logo4];

export default {
  name: "ClientSlider",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return ({
      clientLogos,
    });
  },
};